export const USER_TOKEN_ID = "RAICHE_PANEL_TOKEN_ID"
export const USER_REFRESH_TOKEN = "RAICHE_PANEL_REFRESH_TOKEN"

export const USER_NAME = "RAICHE_PANEL_AUTH_USER_NAME"
export const PASSWORD = "RAICHE_PANEL_AUTH_PASSWORD"

export function setUserToken(token) {
    localStorage.setItem(USER_TOKEN_ID, token)
}

export function getUserToken() {
    return localStorage.getItem(USER_TOKEN_ID)
}

export function removeUserToken() {
    localStorage.removeItem(USER_TOKEN_ID)
}

export function setUserRefreshToken(refreshToken) {
    localStorage.setItem(USER_REFRESH_TOKEN, refreshToken)
}

export function setLoginUserName(username) {
    localStorage.setItem(USER_NAME, username)
}

export function setLoginPassword(password) {
    localStorage.setItem(PASSWORD, password)
}

export function getUserRefreshToken() {
    return localStorage.getItem(USER_REFRESH_TOKEN)
}

export function removeUserRefreshToken() {
    localStorage.removeItem(USER_REFRESH_TOKEN)
}


export function getLoginUserName() {
    return localStorage.getItem(USER_NAME)
}

export function getLoginPassword() {
    return localStorage.getItem(PASSWORD)
}
